import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { QuoteQuestionsPage } from '../pages/quote/quote-questions/quote-questions.page';

@Injectable({
  providedIn: 'root'
})
export class QuoteQuestionsDeactivateGuard  {

  constructor(
    private router: Router,
    private alertCtrl: AlertController) { }

  canDeactivate(
    page: QuoteQuestionsPage,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canLeavePage(page)
  }

 canLeavePage(page: QuoteQuestionsPage): Observable<boolean> | boolean {

    if (page.canLeave || !page.form.dirty) {
      return true;
    }
    else {
      var subject = new Subject<boolean>();
      this.showConfirmationDialog(subject);
      return subject.asObservable();
    }
  }

  async showConfirmationDialog(subject: Subject<boolean>) {
    const confirmDialog = await this.alertCtrl.create({
      header: "Losing Unsaved Data",
      message: "Unsaved changes on the page. Do you want to continue?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => subject.next(false)
        },
        {
          text: "Confirm",
          handler: () => subject.next(true)
        }
      ]
    });
    await confirmDialog.present();
  }
  
}
